
import { IModal, ModalService } from "@/services/modal-service";
import Vue from "vue";
import AppModalItem from "./ModalItem.vue";

export default Vue.extend({
	data(){
		return {
			service: ModalService
		};
	},
	computed: {
		items():IModal[]{
			return this.service.modals;
		}
	},
	methods: {
		closeModal(i:number){
			this.service.modals.splice(i, 1);
		}
	},
	components: {
		AppModalItem
	}
});
